import React from "react";
import Header from "./header";
import Footer from "./footer";
import SignUpBlock from "../blocks/Blocks/SignUpBlock";
import PromoCarouselBlock from "../blocks/Blocks/PromoCarouselBlock";
import BackToTop from "../components/Buttons/BackToTop";
import { useState, useEffect } from "react";
import { Flex } from "theme-ui";
const Layout: React.FC<{
  children: React.ReactNode | React.ReactNode[];
  bottomBanners?: boolean;
}> = ({ children, bottomBanners }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY !== 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div
        sx={{
          py: [2, null, null, 3],
          width: "100%",
          color: "white",
          bg: "brand.green",
          position: "absolute",
          zIndex: 9999,
          top: 0,
          display: "flex",
          justifyContent: "center",
          fontSize: [16, null, null, 18],
          fontWeight: "bold",
          textAlign: "center",
          px: 3,
        }}
      >
        Welcome First Heritage customers in Mississippi and Tennessee!
      </div>
      <div
        id="page"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignCenter: "center",
          flexDirection: "column",
          mt: [40, null, null, 54],
        }}
      >
        <Flex
          sx={{
            // maxWidth: 1920,
            flexDirection: "column",
            alignCenter: "center",
            justifyContent: "center",
          }}
        >
          <div
            sx={{
              bg: "white",
              width: "100%",
              position: "absolute",
              height: 100,
              top: 65,
              zIndex: 9,
            }}
          ></div>
          <Header />
          <div
            id="primary"
            sx={{
              mt: [-80, null, null, -100],
            }}
          >
            {children}
          </div>
          {bottomBanners !== false && (
            <div sx={{ marginTop: "-100px", display: ["block"] }}>
              <PromoCarouselBlock />
            </div>
          )}
          <Footer />
        </Flex>
      </div>
      {isScrolled && <BackToTop />}
    </>
  );
};
export default Layout;
